import { Label } from '@easylife365/react';
import { useTranslation } from 'react-i18next';
import { getTaskStateOptions } from '../../../lib/model';
import type { StatusColumnProps } from './types';

const StatusColumn: React.FC<StatusColumnProps> = ({ status }) => {
  // Subscribes the column to language changes; the option text itself comes from the model helper.
  useTranslation('common');
  const value = getTaskStateOptions().find((p) => p.key === status?.toString())?.text ?? '--';

  return <Label title={value} label={value} />;
};

export default StatusColumn;
